import Cookies from 'js-cookie'
import Storage from './Storage'

const DOMAIN = process.env.VUE_APP_COOKIE_DOMAIN

export default class SharedStorage {
    static get(key: string) {
        const cookieValue = Cookies.get(key, { domain: DOMAIN })

        if (!cookieValue) {
            const storageValue = Storage.get(key)
            if (storageValue) {
                SharedStorage.set(key, storageValue)
            }
            Storage.delete(key)

            return storageValue
        }

        return JSON.parse(cookieValue)
    }

    /**
     * Set a cookie value
     * @param key The key of the cookie
     * @param value The value of the cookie
     * @param expires The number of days until the cookie expires
     */
    static set(key: string, value: string | object, expires?: number | Date) {
        Cookies.set(key, JSON.stringify(value), { expires, domain: DOMAIN })
    }

    static delete(key: string) {
        Cookies.remove(key, { domain: DOMAIN })
    }
}
